import RingLinks from '@jetbrains/ring-ui/components/header/links'
import * as React from 'react'

import {PlaceIdList} from '../../../../pluginSystem/pluginSystem.types'
import Plugin from '../../../common/Plugin/Plugin'
import {
  isPipelinesAgentPageEnabled,
  isPipelinesEnabledInExclusiveMode,
} from '../../../pages/PipelinesPages/utils/featureToggles'

import AdministrationLink from './AdministrationLink/AdministrationLink'
import AgentsLink from './AgentsLink/AgentsLink'
import ChangesLink from './ChangesLink/ChangesLink'
import HomeLink from './HomeLink/HomeLink'
import PipelineAgentsLink from './PipelinesLink/AgentsLink'
import PipelinesLink from './PipelinesLink/PipelinesLink'
import ProjectsLink from './ProjectsLink/ProjectsLink'
import QueueLink from './QueueLink/QueueLink'

import styles from './Links.css'

type Props = {
  adminSpaceAvailable: boolean
}
function Links({adminSpaceAvailable}: Props) {
  return (
    <>
      <HomeLink />
      <RingLinks className={styles.links}>
        {isPipelinesEnabledInExclusiveMode() ? (
          <>
            <PipelinesLink />
            {isPipelinesAgentPageEnabled() && <PipelineAgentsLink />}
          </>
        ) : (
          <>
            <ProjectsLink />
            <ChangesLink />
            <AgentsLink />
            <QueueLink />
          </>
        )}
        {adminSpaceAvailable && <AdministrationLink />}
        <Plugin inline placeId={PlaceIdList.SAKURA_HEADER_NAVIGATION_AFTER} />
      </RingLinks>
    </>
  )
}

export default React.memo(Links)
